// [PURPOSE]: Pure helper utilities for tutorial system — extracted so both the
//   TutorialHelpMenu component and its unit tests can import the same logic.
// [WHY]: Rule 22 — no inline test replicas. Extract, import, assert.
// [INTEGRATION]: TutorialHelpMenu.jsx, __tests__/tutorial/tutorialHelpMenu.test.js

/**
 * Returns the modules that should appear in the Browse/Replay Tours menu.
 *
 * Filtering rules:
 *  - Exclude 'welcome' (it uses WelcomePopup, not the spotlight engine — 0 steps)
 *  - Exclude any module with 0 steps (e.g., step-less stub modules)
 *  - Preserve registry order (insertion order of TUTORIAL_MODULES object)
 *
 * @param {Object} tutorialModules  — TUTORIAL_MODULES registry { id: moduleObj }
 * @returns {Array<{ id: string, title: string, promptMessage?: string, steps: Array }>}
 */
export function getReplayableModules(tutorialModules) {
  return Object.entries(tutorialModules)
    .filter(([id, mod]) => {
      if (id === 'welcome') return false;
      if (!mod || !Array.isArray(mod.steps) || mod.steps.length === 0) return false;
      return true;
    })
    .map(([, mod]) => mod);
}
